const apiHost = process.env.API_HOST
const apiRoot = 'v1'

const _generateSailsEndpoint = (object, action) => {
  return apiHost + apiRoot + object + action
}

let endpoints = {}
endpoints.baseUrl = _generateSailsEndpoint('', '')

export default endpoints



// WEBPACK FOOTER //
// ./src/api/endpoints.js